import React from 'react';
import {Highlight} from 'react-instantsearch-dom';
import PropTypes from 'prop-types';

export default function TeaserNode(props) {

  return (
    <div className="views-row">
      <div className="node node--type-news node--view-mode-search-index ds-1col clearfix">
        <div className="node-detail-columns">

          <div className="node-detail-column-left">
            {props.hit.hasOwnProperty('styled_image_url') ? (
              <div
                className="field field--name-field-media-image field--type-entity-reference field--label-hidden field__item">
                <a href={props.hit.entity_alias} hrefLang="nl">
                  <img
                    src={props.hit.styled_image_url}
                    alt={props.hit.content_title} loading="lazy" typeof="foaf:Image"/>
                </a>
              </div>
            ) : null}
          </div>

          <div className="node-detail-column-right">
            <div className="field field--name-node-title field--type-ds field--label-hidden">
              <a href={props.hit.entity_alias} hrefLang="nl">
                <Highlight attribute="content_title" hit={props.hit}/>
              </a>
            </div>

            <strong>{props.hit.entity_bundle_processed}</strong>

            <div className="field field--name-body field--type-text-with-summary field--label-hidden field__item">
              <div dangerouslySetInnerHTML={{__html: props.hit.content_body}}></div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

TeaserNode.propTypes = {
  hit: PropTypes.object.isRequired,
};
